import TopBar from '../../components/TopBar';
import { TransactionsCard } from '../transactionsPage';

interface HomePageProps {
  userId: string;
}

const HomePage = ({ userId }: HomePageProps) => (
  <>
    <TopBar
      affiliateId={userId}
    />
    <TransactionsCard userId={userId} />
  </>
);

export default HomePage;
